import httpClient from "@/plugins/axios";

export const getDepartments = async () => {
    const response = await httpClient.get(`/admin/v1/departments/`);
    return response;
}

export const getDepartment = async (departmentId) => {
    const response = await httpClient.get(`/admin/v1/departments/${departmentId}/?translations=1`);
    return response;
}

export const saveDepartment = async (department) => {
    if (department.id) {
        return await updateDepartment(department.id, department);
    }
    else {
        return await insertDepartment(department);
    }
}

const insertDepartment = async (formData) => {
    const response = await httpClient.post('/admin/v1/departments/', formData)
    return response;
}

const updateDepartment = async (id, formData) => {
    const response = await httpClient.put(`/admin/v1/departments/${id}/`, formData)
    return response;
}

export const deleteDepartment = async (id) => {
    const response = httpClient.delete(`/admin/v1/departments/${id}/`);
    return response;
}

